import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-unification-status',
  templateUrl: './business-unification-status.component.html',
  styleUrls: ['./business-unification-status.component.scss'],
})
/**
 * Business Unification Status Atom
 */
export class BusinessUnificationStatusComponent implements OnInit {
  @Input() status?: string;

  /**
   * on init
   */
  ngOnInit() {
    this.status = this.status?.toLowerCase();
  }

  /**
   * Function to transforma a word in kebab case
   * @param {string} word
   * @return {string}
   */
  toKebabCase(word: string): string {
    return word.replace('_', '-');
  }

  /**
   * Function to cappitalize the first letter of a word
   * @param {string} word
   * @return {string}
   */
  capitalizeFirstLetter(word: string): string {
    const cappitalized = word.charAt(0).toUpperCase() + word.slice(1);
    return cappitalized.replace('_', ' ');
  }
}
